import React, { useEffect } from "react";
import { termsSeo, setPageSeo } from "../seo";
import cardsWhiteLogoUrl from "../assets/Logo - Cards - white.svg";

const privacyPolicyUrl = "/privacy-policy";

const termsText = `TERMINI E CONDIZIONI OFC CARDS

Ultimo aggiornamento: 30 aprile 2026

I presenti Termini e Condizioni disciplinano l'utilizzo del servizio "OFC Cards", fornito da OFC S.R.L., accessibile tramite il dominio cards.ofc.link e relativi sottodomini, pagine, dashboard, link, QR code, NFC o altri strumenti digitali collegati.

Utilizzando OFC Cards, l'utente accetta i presenti Termini e Condizioni.

1. TITOLARE DEL SERVIZIO

Il servizio è fornito da:

OFC S.R.L.
Viale San Nilo 39C, 00046 Grottaferrata (RM) - Italia
P.IVA: 16390181002
PEC: ofc@pecformail.it
Telefono: 0694502976
Email: info@onoranzefunebricloud.com

2. DEFINIZIONI

Ai fini dei presenti Termini si intende per:

"OFC" o "Fornitore": OFC S.R.L.

"OFC Cards" o "Servizio": il servizio digitale che consente di creare, pubblicare, gestire e condividere card digitali, profili pubblici, landing page, pagine contatto, pagine promozionali o altri contenuti online.

"Card": la pagina digitale generata tramite OFC Cards, accessibile tramite link, QR code, NFC o altri strumenti.

"Landing pubblica": una pagina pubblica realizzata o gestita tramite OFC Cards, anche con finalità informative, commerciali, promozionali, di raccolta contatti o richiesta informazioni.

"Cliente": il soggetto, persona fisica o giuridica, professionista, impresa, ente o organizzazione che utilizza, attiva o richiede il Servizio.

"Utente": qualsiasi soggetto che visita una card, visita una landing, compila un modulo, richiede informazioni o utilizza il Servizio.

"Contenuti": testi, immagini, fotografie, loghi, dati, recapiti, link, file, descrizioni, promozioni o qualsiasi altro materiale inserito o pubblicato tramite il Servizio.

3. OGGETTO DEL SERVIZIO

OFC Cards consente di creare e gestire pagine digitali accessibili online, anche tramite link, QR code o NFC.

Il Servizio può includere, a titolo esemplificativo:

- creazione di card digitali e profili pubblici;
- pubblicazione di dati di contatto, testi, immagini, loghi e link;
- creazione di landing pubbliche;
- generazione di link, QR code o collegamenti NFC;
- gestione e modifica dei contenuti;
- raccolta di richieste tramite form, ove previsto;
- accesso e verifica tramite email e codice OTP;
- gestione di coupon, promozioni o iniziative commerciali;
- strumenti di pubblicazione, oscuramento, sospensione o rimozione.

Le funzionalità disponibili possono variare in base alla configurazione tecnica, al piano attivato o agli accordi applicabili.

4. DESTINATARI E FINALITÀ DEL SERVIZIO

OFC Cards è pensato principalmente per profili, attività, operatori, professionisti, aziende, collaboratori, partner o soggetti collegati al settore funebre, ai servizi connessi o alle iniziative promosse tramite OFC S.R.L.

Il Servizio può essere utilizzato anche per pagine informative, commerciali, promozionali o di contatto, purché coerenti con le finalità del Servizio e con i presenti Termini.

OFC si riserva il diritto di rifiutare, sospendere o interrompere l'utilizzo del Servizio qualora l'uso risulti non coerente con le finalità del Servizio, anomalo, non verificabile, abusivo o potenzialmente lesivo per OFC, i Clienti, gli utenti o terzi.

5. REGISTRAZIONE E ACCESSO TRAMITE EMAIL E OTP

Per creare, attivare o gestire una card può essere richiesto l'inserimento di un indirizzo email.

OFC Cards non prevede necessariamente un sistema di login tradizionale con password. L'accesso alla gestione della card può avvenire tramite codice OTP, link temporaneo o altro meccanismo di verifica inviato all'indirizzo email indicato.

L'utente o il Cliente si impegna a:

- fornire un indirizzo email corretto, attivo e nella propria disponibilità;
- non utilizzare email di terzi senza autorizzazione;
- custodire con attenzione l'accesso alla propria casella email;
- non condividere codici OTP o link temporanei con soggetti non autorizzati;
- informare OFC in caso di accesso non autorizzato, uso improprio o sospetto abuso.

Il codice OTP o link di verifica è personale, temporaneo e finalizzato alla gestione della card o delle funzionalità richieste.

OFC può limitare, sospendere o bloccare temporaneamente l'invio di OTP o l'accesso in caso di richieste anomale, tentativi ripetuti, abuso, sospetto utilizzo fraudolento o rischio per la sicurezza del Servizio.

6. CREAZIONE E PUBBLICAZIONE DELLE CARD

Il Cliente o l'utente autorizzato può creare una o più card inserendo i contenuti richiesti o disponibili.

La pubblicazione di una card comporta che i contenuti possano essere accessibili tramite link, QR code, NFC, strumenti di condivisione o altri canali.

L'utente prende atto che:

- una card può essere visibile a chiunque disponga del link;
- una card può essere condivisa da terzi;
- eventuali QR code o supporti fisici già distribuiti possono continuare a rimandare all'URL associato;
- OFC non può impedire screenshot, copie, salvataggi o condivisioni effettuate da terzi.

7. LANDING PUBBLICHE E FORM

Il Servizio può includere landing pubbliche con finalità informative, commerciali, promozionali, di richiesta contatto, richiesta demo, attivazione servizio o partecipazione a iniziative.

La semplice navigazione su una card o landing pubblica non comporta, salvo esigenze tecniche e analytics anonimizzati o aggregati, la raccolta diretta di dati identificativi del visitatore pubblico.

OFC può raccogliere dati personali solo quando l'utente li fornisce volontariamente, ad esempio tramite:

- form di contatto;
- richiesta informazioni;
- richiesta demo;
- richiesta di attivazione;
- richiesta coupon o promozione;
- verifica tramite email o OTP;
- comunicazioni inviate via email, telefono, WhatsApp o altri canali.

I dati raccolti sono trattati secondo quanto indicato nella Privacy Policy.

8. RESPONSABILITÀ SUI CONTENUTI

Il Cliente o l'utente che crea, modifica o pubblica una card, una landing o altri contenuti è responsabile dei contenuti inseriti.

In particolare, dichiara e garantisce:

- di avere titolo o autorizzazione per pubblicare i contenuti;
- che i contenuti sono corretti, leciti, aggiornati e non ingannevoli;
- che immagini, loghi, marchi, testi, recapiti e link sono utilizzati legittimamente;
- che la pubblicazione non viola diritti di terzi, inclusi privacy, immagine, nome, reputazione, marchi, copyright o altri diritti;
- che eventuali dati di terzi sono stati inseriti con adeguata autorizzazione;
- che i contenuti promozionali, coupon o iniziative commerciali sono veritieri e trasparenti.

OFC non effettua un controllo preventivo sistematico sui contenuti pubblicati e non è responsabile della loro correttezza, liceità o completezza, salvo i casi previsti dalla legge.

9. CONTENUTI VIETATI

È vietato utilizzare OFC Cards per pubblicare o trasmettere contenuti che:

- siano illeciti, falsi, ingannevoli o fraudolenti;
- siano offensivi, diffamatori, discriminatori, minacciosi o lesivi della dignità personale;
- violino privacy, immagine, nome, reputazione o riservatezza di terzi;
- contengano dati personali di terzi senza autorizzazione;
- contengano dati particolari o dati di minori senza adeguata base giuridica;
- violino diritti d'autore, marchi o altri diritti di proprietà intellettuale;
- contengano malware, virus o codice dannoso;
- promuovano attività, beni o servizi vietati dalla legge;
- presentino promozioni, coupon o vantaggi in modo ingannevole;
- utilizzino identità, loghi, marchi, immagini, recapiti o link non autorizzati o non verificabili;
- siano riconducibili a profili falsi, simulati o creati con finalità elusive, fraudolente o abusive;
- siano contrari alle finalità del Servizio.

10. VERIFICHE, USO ANOMALO, SOSPENSIONE E RIMOZIONE

OFC si riserva il diritto di effettuare controlli, anche successivi alla pubblicazione, sull'utilizzo del Servizio, sull'autenticità dei dati inseriti e sulla coerenza della card o della landing con le finalità del Servizio.

OFC potrà richiedere informazioni, chiarimenti o documentazione utile a verificare, a titolo esemplificativo:

- identità o legittimazione del soggetto che gestisce la card;
- titolarità o autorizzazione all'uso di nomi, marchi, loghi, immagini, recapiti o link;
- autenticità e correttezza dei dati pubblicati;
- coerenza della card con le finalità del Servizio;
- assenza di usi illeciti, ingannevoli, fraudolenti, abusivi o non autorizzati.

In caso di mancato riscontro, riscontro incompleto, impossibilità di verificare i dati, uso anomalo, uso improprio o utilizzo non coerente con le finalità del Servizio, OFC potrà:

- sospendere temporaneamente la card o la landing;
- limitarne la visibilità;
- disattivare link, QR code, NFC o funzionalità collegate;
- richiedere modifiche o integrazioni;
- rimuovere contenuti specifici;
- eliminare la card o la landing;
- sospendere o bloccare l'accesso alla gestione;
- rifiutare nuove attivazioni.

OFC potrà adottare tali misure anche senza preavviso nei casi di urgenza, rischio per la sicurezza, contenuti manifestamente illeciti, segnalazioni motivate, tutela di terzi o rischio legale, tecnico o reputazionale.

La sospensione o eliminazione della card non comporta, salvo diverso obbligo di legge o accordo scritto, alcun diritto automatico a rimborsi, indennizzi o risarcimenti.

11. SEGNALAZIONE DI CONTENUTI

Chiunque ritenga che una card, una landing o un contenuto pubblicato tramite OFC Cards violi diritti propri o di terzi può inviare una segnalazione a:

info@onoranzefunebricloud.com

La segnalazione dovrebbe includere:

- URL della card o della landing;
- descrizione del contenuto contestato;
- motivo della richiesta;
- dati e recapiti del segnalante;
- eventuale documentazione utile.

OFC valuterà la segnalazione e potrà adottare le misure ritenute opportune, inclusi oscuramento temporaneo, richiesta di chiarimenti, modifica, sospensione o rimozione dei contenuti.

12. VISIBILITÀ, INDICIZZAZIONE E CONDIVISIONE

Salvo diversa configurazione, card e landing pubbliche possono essere accessibili tramite link pubblico.

OFC può prevedere impostazioni tecniche per limitare l'indicizzazione da parte dei motori di ricerca, come l'utilizzo di impostazioni "noindex", ove disponibili.

L'utente prende atto che:

- la non indicizzazione non equivale a riservatezza assoluta;
- i motori di ricerca possono impiegare tempo per rimuovere contenuti già indicizzati;
- OFC non controlla la condotta di motori di ricerca, social network, app di messaggistica o terzi;
- la condivisione del link, del QR code o del supporto NFC rende la pagina accessibile ai destinatari della condivisione.

13. STATISTICHE E ANALYTICS

OFC Cards può utilizzare strumenti analytics anonimizzati o aggregati, come OpenPanel o strumenti analoghi, per misurare visualizzazioni, performance, traffico e utilizzo generale del Servizio sulle pagine pubbliche.

Per gli utenti che accedono all'area gestione tramite email, OTP o link temporaneo, OFC può inoltre associare al profilo verificato e alla card o azienda collegata eventi tecnici di utilizzo delle funzionalità, ad esempio creazione o aggiornamento card, uso di QR code, firma email, Avatar AI, ricerca P.IVA o acquisto crediti.

Le statistiche possono includere, ad esempio:

- numero di visite;
- pagine visualizzate;
- provenienza approssimativa del traffico;
- dispositivo o browser in forma generale;
- eventi aggregati;
- performance generali del servizio.

Tali statistiche non sono finalizzate all'identificazione dei singoli visitatori e non sono utilizzate per profilazione pubblicitaria, remarketing o pubblicità comportamentale, salvo diversa informativa e, ove necessario, consenso.

Le statistiche hanno finalità informativa e possono essere soggette a limiti tecnici, approssimazioni o variazioni dovute agli strumenti utilizzati.

14. FORM, CONTATTI E INTERAZIONI

Salvo diversa indicazione, le card pubbliche non raccolgono dati personali dei visitatori tramite form.

Eventuali moduli di contatto, richiesta informazioni, richiesta demo, assistenza, registrazione, accesso, richiesta coupon o altre interazioni possono essere presenti su landing pubbliche, sito commerciale, dashboard, area riservata o altre pagine specifiche.

L'utente che utilizza tali moduli si impegna a non:

- inviare spam;
- inviare contenuti offensivi, illeciti o ingannevoli;
- inviare comunicazioni commerciali non autorizzate;
- trasmettere malware o contenuti dannosi;
- impersonare terzi;
- violare diritti di OFC, del Cliente o di terzi.

15. COUPON, PROMOZIONI E INIZIATIVE COMMERCIALI

Il Servizio può consentire agli utenti di richiedere, attivare o utilizzare coupon, promozioni, agevolazioni, vantaggi, convenzioni o iniziative commerciali.

Le condizioni specifiche di ciascuna iniziativa, quali durata, benefici, limiti, requisiti, disponibilità, esclusioni o modalità di utilizzo, saranno indicate nella relativa pagina, modulo, comunicazione o materiale informativo.

L'utente prende atto che:

- coupon e promozioni possono essere soggetti a limiti temporali, quantitativi, territoriali o commerciali;
- la disponibilità può essere limitata;
- OFC può verificare la validità della richiesta;
- OFC può rifiutare l'applicazione della promozione in caso di uso improprio, duplicato, fraudolento o non conforme;
- salvo diversa indicazione, coupon e promozioni non sono cumulabili, cedibili, convertibili in denaro o rimborsabili.

16. QR CODE, NFC E SUPPORTI FISICI

Il Servizio può prevedere la generazione di QR code o l'associazione a supporti NFC, cartacei, digitali o fisici.

L'utente prende atto che:

- QR code e supporti NFC rimandano a un URL o contenuto digitale;
- la disponibilità della pagina collegata dipende dalla continuità del Servizio e dalle condizioni applicabili;
- eventuali materiali già stampati o distribuiti non possono essere modificati fisicamente da OFC;
- in caso di rimozione o disattivazione della card o della landing, il QR code o il supporto NFC potrebbe non condurre più al contenuto originario.

17. DURATA DELLE CARD E DELLE LANDING

La durata di pubblicazione delle card e delle landing dipende dal piano, dall'accordo commerciale, dalla configurazione tecnica o dalle impostazioni del Servizio.

Salvo diverso accordo scritto, OFC potrà mantenere attiva la card o la landing per il periodo previsto dal piano, dal contratto o dalla specifica iniziativa.

OFC non garantisce la disponibilità permanente o illimitata delle card, delle landing, dei coupon o delle promozioni, salvo esplicito accordo scritto.

Alla cessazione del rapporto, alla scadenza del piano, alla conclusione dell'iniziativa, alla richiesta di rimozione o in caso di violazione dei presenti Termini, OFC potrà sospendere, archiviare, oscurare o cancellare la card, la landing o i contenuti collegati.

18. OBBLIGHI DEL CLIENTE

Il Cliente si impegna a:

- utilizzare il Servizio nel rispetto della legge;
- rispettare i presenti Termini;
- fornire dati e contenuti corretti, aggiornati, autentici e verificabili;
- non utilizzare il Servizio per finalità illecite o abusive;
- gestire in modo sicuro l'email associata alla card, i codici OTP e i link temporanei;
- ottenere le autorizzazioni necessarie per la pubblicazione dei contenuti;
- mantenere aggiornate le informazioni pubblicate;
- rispettare gli obblighi privacy verso eventuali soggetti i cui dati siano pubblicati o trattati tramite il Servizio;
- collaborare con OFC in caso di richieste di verifica, segnalazioni, reclami o rimozioni.

19. MANLEVA

Il Cliente si impegna a manlevare e tenere indenne OFC S.R.L., i suoi amministratori, collaboratori, fornitori e partner da richieste, danni, responsabilità, costi, sanzioni o spese derivanti da:

- uso illecito o improprio del Servizio;
- violazione dei presenti Termini;
- violazione di diritti di terzi;
- pubblicazione di contenuti non autorizzati, inesatti, illeciti o non aggiornati;
- mancato ottenimento di consensi, autorizzazioni o basi giuridiche necessarie;
- utilizzo di identità, loghi, marchi, recapiti, immagini, link o dati non autentici, non autorizzati o non verificabili;
- mancata collaborazione alle richieste di verifica effettuate da OFC;
- violazioni privacy, commerciali, pubblicitarie o consumeristiche imputabili al Cliente.

20. DISPONIBILITÀ DEL SERVIZIO

OFC si impegna a fornire il Servizio con diligenza professionale.

Il Servizio può tuttavia essere temporaneamente non disponibile per manutenzioni, aggiornamenti, malfunzionamenti, interruzioni di rete, problemi di fornitori terzi, cause di forza maggiore, attacchi informatici o eventi non ragionevolmente controllabili da OFC.

OFC non garantisce che il Servizio sia sempre disponibile, ininterrotto, privo di errori o compatibile con qualsiasi dispositivo, browser o sistema.

21. LIMITAZIONE DI RESPONSABILITÀ

Nei limiti consentiti dalla legge, OFC non sarà responsabile per:

- contenuti inseriti dal Cliente o dagli utenti;
- errori, omissioni o inesattezze presenti nelle card o landing;
- pubblicazione di dati non autorizzati;
- uso improprio di link, QR code o supporti NFC;
- condivisioni, screenshot, copie, download o archiviazioni effettuate da terzi;
- indicizzazione o mancata deindicizzazione da parte dei motori di ricerca;
- mancata applicazione di coupon o promozioni per uso non conforme o requisiti non rispettati;
- sospensione, rimozione o cancellazione di card, landing o contenuti in caso di uso anomalo, dati non verificabili, mancata collaborazione o non coerenza con le finalità del Servizio;
- perdita di opportunità, danni indiretti, perdita di dati, perdita di ricavi o danni reputazionali, salvo i casi inderogabili di legge;
- malfunzionamenti dipendenti da fornitori terzi, connettività, dispositivi o sistemi dell'utente.

Resta ferma la responsabilità di OFC nei casi di dolo o colpa grave e negli altri casi in cui la legge non consenta limitazioni di responsabilità.

22. PROPRIETÀ INTELLETTUALE

Il Servizio, la piattaforma, il software, il layout, l'interfaccia, i marchi, i loghi, la documentazione, le grafiche, i template e ogni elemento sviluppato da OFC sono di proprietà di OFC S.R.L. o dei rispettivi titolari.

L'utilizzo del Servizio non comporta alcun trasferimento di diritti di proprietà intellettuale al Cliente o all'utente.

Il Cliente mantiene la titolarità dei contenuti caricati, fatto salvo il diritto concesso a OFC di utilizzarli nella misura necessaria all'erogazione del Servizio.

23. LICENZA SUI CONTENUTI

Caricando o inserendo contenuti nel Servizio, il Cliente concede a OFC una licenza non esclusiva, gratuita, limitata e valida per il tempo necessario all'erogazione del Servizio, per:

- ospitare i contenuti;
- pubblicarli nella card o landing;
- renderli accessibili tramite link, QR code, NFC o altri strumenti;
- adattarli tecnicamente ai formati richiesti;
- effettuare copie tecniche, backup e operazioni necessarie alla sicurezza e continuità del Servizio;
- generare anteprime, miniature, link, QR code o altri elementi funzionali.

24. PRIVACY E DATI PERSONALI

Il trattamento dei dati personali avviene secondo quanto indicato nella Privacy Policy di OFC Cards, disponibile al seguente link:

${privacyPolicyUrl}

I dati eventualmente raccolti tramite form, richieste di contatto, registrazione, accesso o verifica tramite OTP email sono trattati per gestire la richiesta, verificare l'utente, consentire la creazione e gestione della card, attivare le funzionalità richieste e prevenire abusi.

Tali dati non saranno utilizzati per finalità promozionali senza consenso specifico e separato, salvo i casi consentiti dalla normativa applicabile.

25. COOKIE, ANALYTICS E STRUMENTI DI TRACCIAMENTO

Le card pubbliche e le landing pubbliche di OFC Cards non utilizzano cookie di profilazione, salvo diversa indicazione resa all'utente tramite apposito banner o meccanismo di consenso.

OFC può utilizzare strumenti analytics anonimizzati o aggregati, come OpenPanel o strumenti analoghi, per misurare visualizzazioni, performance, traffico e utilizzo generale del Servizio, senza identificare direttamente il singolo visitatore pubblico.

Nell'area gestione autenticata, alcuni eventi tecnici possono essere collegati al profilo verificato e alla card o azienda associata per sicurezza, assistenza, misurazione dell'adozione delle funzionalità e miglioramento del prodotto.

L'eventuale inserimento futuro di cookie analytics non anonimizzati, strumenti di marketing, remarketing, pixel pubblicitari o tecnologie analoghe sarà subordinato, ove previsto, al consenso dell'utente.

26. CORRISPETTIVI, PAGAMENTI E PIANI

Le condizioni economiche del Servizio, ove previste, sono indicate nella pagina di acquisto, nel contratto, nel piano, nell'accordo commerciale o nella documentazione applicabile.

Salvo diversa indicazione scritta:

- i prezzi si intendono al netto di IVA, ove applicabile;
- i pagamenti devono essere effettuati secondo le modalità concordate;
- il mancato pagamento può comportare la sospensione o cessazione del Servizio;
- eventuali rinnovi, canoni o costi ricorrenti sono disciplinati dal piano applicabile.

27. RECESSO, SOSPENSIONE E CESSAZIONE

Il Cliente può richiedere la cessazione del Servizio secondo le modalità previste dal piano, dal contratto o dalla documentazione applicabile.

OFC può sospendere o cessare il Servizio in caso di:

- mancato pagamento;
- uso illecito, improprio, anomalo o abusivo;
- violazione dei presenti Termini;
- rischio per la sicurezza della piattaforma;
- richiesta di autorità competenti;
- contenuti illeciti o contestati;
- promozioni o iniziative non conformi;
- impossibilità di verificare l'autenticità dei dati pubblicati;
- mancata collaborazione alle richieste di verifica;
- utilizzo non coerente con le finalità di OFC Cards;
- rischio di danno legale, tecnico, commerciale o reputazionale per OFC, i Clienti o i partner.

Alla cessazione del Servizio, OFC potrà disattivare, archiviare o cancellare card, landing e contenuti secondo le condizioni applicabili e nel rispetto degli obblighi di legge.

28. MODIFICHE AL SERVIZIO

OFC si riserva il diritto di modificare, aggiornare, sospendere, sostituire o interrompere, in tutto o in parte, funzionalità del Servizio per ragioni tecniche, organizzative, commerciali, normative o di sicurezza.

OFC cercherà, ove ragionevolmente possibile, di informare i Clienti in caso di modifiche rilevanti.

29. MODIFICHE AI TERMINI

OFC si riserva il diritto di modificare i presenti Termini e Condizioni.

La versione aggiornata sarà pubblicata sul sito o comunicata con modalità idonee.

L'utilizzo del Servizio dopo la pubblicazione delle modifiche comporta l'accettazione dei nuovi Termini, salvo diverso diritto di recesso ove previsto dalla legge o dal contratto.

30. FORZA MAGGIORE

OFC non sarà responsabile per ritardi, interruzioni o inadempimenti dovuti a eventi di forza maggiore o comunque al di fuori del proprio ragionevole controllo, inclusi calamità naturali, guerre, scioperi, interruzioni di energia o rete, provvedimenti delle autorità, attacchi informatici, malfunzionamenti di fornitori terzi o eventi eccezionali.

31. LEGGE APPLICABILE E FORO COMPETENTE

I presenti Termini e Condizioni sono regolati dalla legge italiana.

Nel caso di Cliente professionista, impresa, ente o organizzazione, salvo diverso accordo scritto, sarà competente in via esclusiva il Foro di Roma.

Restano ferme le disposizioni inderogabili applicabili ai consumatori, ove il Cliente o l'utente agisca in qualità di consumatore.

32. CONTATTI

Per informazioni, assistenza, segnalazioni o richieste relative al Servizio:

OFC S.R.L.
Viale San Nilo 39C, 00046 Grottaferrata (RM) - Italia
P.IVA: 16390181002
PEC: ofc@pecformail.it
Telefono: 0694502976
Email: info@onoranzefunebricloud.com`;

const isSectionTitle = (line) => /^\d+\.\s/.test(line);

const renderParagraph = (line, key) => {
  if (line === privacyPolicyUrl) {
    return (
      <p key={key} className="text-sm leading-7 text-slate-700">
        <a
          href={privacyPolicyUrl}
          target="_blank"
          rel="noreferrer"
          className="font-bold text-[#13526f] underline decoration-cyan-500/40 underline-offset-2"
        >
          {privacyPolicyUrl}
        </a>
      </p>
    );
  }

  return (
    <p key={key} className="text-sm leading-7 text-slate-700">
      {line}
    </p>
  );
};

const renderTermsContent = () => {
  const lines = termsText.split("\n");
  const nodes = [];
  let listItems = [];

  const flushList = () => {
    if (!listItems.length) {
      return;
    }

    nodes.push(
      <ul
        key={`list-${nodes.length}`}
        className="list-disc space-y-2 pl-5 text-sm leading-7 text-slate-700"
      >
        {listItems.map((item, index) => (
          <li key={`${item}-${index}`}>{item}</li>
        ))}
      </ul>,
    );
    listItems = [];
  };

  lines.forEach((rawLine, index) => {
    const line = rawLine.trim();

    if (!line) {
      flushList();
      return;
    }

    if (line.startsWith("- ")) {
      listItems.push(line.slice(2));
      return;
    }

    flushList();

    if (index === 0) {
      nodes.push(
        <h1
          key="title"
          className="text-3xl font-extrabold leading-tight text-slate-950 sm:text-5xl"
        >
          {line}
        </h1>,
      );
      return;
    }

    if (line.startsWith("Ultimo aggiornamento:")) {
      nodes.push(
        <p
          key="updated"
          className="text-xs font-extrabold uppercase tracking-[0.14em] text-[#1b8395]"
        >
          {line}
        </p>,
      );
      return;
    }

    if (isSectionTitle(line)) {
      nodes.push(
        <h2
          key={`section-${index}`}
          className="pt-8 text-xl font-extrabold leading-tight text-slate-950 sm:text-2xl"
        >
          {line}
        </h2>,
      );
      return;
    }

    nodes.push(renderParagraph(line, `p-${index}`));
  });

  flushList();
  return nodes;
};

function TermsPage() {
  useEffect(() => {
    setPageSeo(termsSeo);
  }, []);

  return (
    <div className="min-h-screen bg-[#e8eef2] font-Poppins text-slate-950">
      <header className="bg-[#17465c] text-white">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-3 py-4 sm:px-5">
          <a href="/" className="flex items-center">
            <img
              src={cardsWhiteLogoUrl}
              alt="Cards"
              className="h-9 w-auto"
            />
          </a>
          <a
            href="/"
            className="rounded-md bg-white/10 px-3 py-2 text-xs font-bold text-white ring-1 ring-white/20 transition hover:bg-white/15"
          >
            Homepage
          </a>
        </div>
      </header>

      <main className="px-4 py-8 sm:px-5 sm:py-12">
        <article className="mx-auto max-w-4xl rounded-lg bg-white px-5 py-8 shadow-xl shadow-slate-950/10 ring-1 ring-slate-200 sm:px-8 sm:py-10">
          <div className="space-y-5">{renderTermsContent()}</div>
        </article>
      </main>
    </div>
  );
}

export default TermsPage;
